/**
 * Status of an XP boost
 */
export type BoostStatus = 'AVAILABLE' | 'ACTIVE' | 'EXPIRED' | 'USED_TODAY';

export interface BoostStatusConfig {
  label: string;
  description: string;
  canActivate: boolean;
}

export const BOOST_STATUS_CONFIG: Record<BoostStatus, BoostStatusConfig> = {
  AVAILABLE: {
    label: 'Disponible',
    description: 'Puedes activar el boost ahora',
    canActivate: true,
  },
  ACTIVE: {
    label: 'Activo',
    description: 'El boost está activo (2x XP)',
    canActivate: false,
  },
  EXPIRED: {
    label: 'Expirado',
    description: 'El boost ha terminado',
    canActivate: true,
  },
  USED_TODAY: {
    label: 'Usado hoy',
    description: 'Ya usaste el boost hoy, vuelve mañana',
    canActivate: false,
  },
};

export function getBoostStatusConfig(status: BoostStatus): BoostStatusConfig {
  return BOOST_STATUS_CONFIG[status];
}

export function canActivateBoost(status: BoostStatus): boolean {
  return BOOST_STATUS_CONFIG[status].canActivate;
}

export const BOOST_DURATION_MINUTES = 15;
export const BOOST_MULTIPLIER = 2.0;
